import { render } from "./SidePanel.vue?vue&type=template&id=07479424"
import script from "./SidePanel.js?vue&type=script&lang=js"
export * from "./SidePanel.js?vue&type=script&lang=js"

import "./SidePanel.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/korean-handbook/korean-handbook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__